<template>
  <div class="quiz-container quiz-ui-question mt-14 sm:grid sm:grid-cols-[1.5fr,1fr] gap-20 gap-y-2">
    <div class="col-span-2 mb-10 text-2xl font-bold animated fadeInUp hidden sm:block">{{ question.question }}</div>
    <div class="flex gap-2 block sm:hidden">
      <div class="col-span-2 mb-10 text-2xl font-bold leading-tight animated fadeInUp">{{ question.question }}</div>
      <a class="flex items-center justify-center flex-shrink-0 w-12 h-12 border border-solid rounded-full sm:hidden" @click="funRequestconsult">
        <div
          class="flex items-center justify-center flex-shrink-0 w-10 h-10 border border-solid rounded-full border-color"
        >
          <div class="flex items-center justify-center w-8 h-8 rounded-full bg-light">
            <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.62447 9.05882V7.99426C7.59494 7.7934 8.41772 7.31133 8.98734 6.70875C9.66245 5.98565 10 5.04161 10 4.17791C10 2.97274 9.43038 1.98852 8.67089 1.3056C7.91139 0.622669 6.70886 0 4.93671 0C3.16456 0 1.96203 0.642755 1.26582 1.3056C0.632911 1.90818 0.0632912 2.8924 0 4.15782H3.71308C3.71308 3.7561 3.86076 3.37446 4.09283 3.15352C4.2827 2.95265 4.59916 2.81205 5 2.81205C5.40084 2.81205 5.78059 2.95265 6.01266 3.19369C6.26582 3.43472 6.37131 3.81636 6.37131 4.13773C6.37131 4.51937 6.20253 4.94118 5.88608 5.24247C5.37975 5.72453 4.55696 5.90531 3.90295 5.90531C3.62869 5.90531 3.41772 5.86514 3.18565 5.80488V9.05882H6.62447ZM5 14C5.54852 14 6.09705 13.7991 6.54008 13.3773C6.91983 13.0158 7.173 12.5739 7.173 11.911C7.173 11.2482 6.91983 10.8063 6.56118 10.4648C6.09705 10.023 5.52743 9.8221 4.9789 9.8221C4.51477 9.8221 3.96624 9.9627 3.45992 10.4448C3.18565 10.7059 2.80591 11.1879 2.80591 11.911C2.80591 12.6341 3.18565 13.1162 3.45992 13.3773C3.96624 13.8594 4.53586 14 5 14Z"
                fill="#3D4A6C"
              />
            </svg>
          </div>
        </div>
      </a>
    </div>
    <!-- блок выбора -->
    <div>
      <img v-if="question.image" class="object-cover w-full mb-4 rounded-xl h-36 sm:hidden" :src="question.image" />
      <div class="grid grid-cols-2 gap-4 q1">
        <div
            class="duration-300 cursor-pointer option bg-light rounded-xl hover:scale-105 animated fadeInUp"
            :style="`animation-delay: ${index * 100}ms`"
            :class="[{ 'col-span-2': option.wide }]"
            v-for="(option, index) in question.options"
            :key="index"
            @click="select(option)"
        >
          <img v-if="option.image" class="rounded-t-xl" :src="option.image" style="width: 100%;"/>
          <div class="flex gap-2 p-4">
            <div
                class="w-6 h-6 border border-black border-solid rounded-full border-opacity-20"
                :class="[{ 'bg-accent': value === option.value }]"
            ></div>
            {{ option.value }}
          </div>
        </div>
      </div>
    </div>
    <!-- блок картинка справа и пред результ  -->
    <div>
      <img v-if="question.image" class="hidden object-cover w-full rounded-xl h-36 sm:block mb-4" :src="question.image" />
      <!-- По результатам теста вы получите -->
      <div class="hidden p-4 bg-light rounded-xl sm:block" v-if="question.surprise">
        <div class="flex items-center justify-center gap-2 font-bold text-center">
          <div class="flex items-center justify-center bg-gray-700 rounded-md w-7 h-7">
            <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.96765 0C6.26523 0 6.53046 0.0156281 6.69542 0.0437585C6.83774 0.071889 7.07709 0.121899 7.22911 0.159406C7.38113 0.196913 7.60431 0.265677 7.73046 0.309435C7.8566 0.35632 8.05714 0.443837 8.18329 0.506349C8.30943 0.565735 8.54879 0.703262 8.71698 0.812659C8.88517 0.922055 9.16011 1.13772 9.3283 1.294C9.4965 1.45028 9.71644 1.68158 9.81671 1.80973C9.92022 1.93788 10.069 2.15042 10.1499 2.27857C10.2307 2.40672 10.3601 2.64739 10.4313 2.80992C10.5057 2.97246 10.5995 3.21938 10.6415 3.35691C10.6836 3.49443 10.7418 3.73198 10.7709 3.88826C10.8194 4.12268 10.8323 4.44149 10.8679 7.4202L11.0943 7.50147C11.2205 7.54522 11.3951 7.60774 11.4825 7.63899C11.573 7.67337 11.6992 7.74839 11.7671 7.80778C11.835 7.87029 11.9159 7.98281 11.945 8.06095C11.9968 8.1891 12 8.46728 12 11.3272C12 14.1809 11.9968 14.4653 11.945 14.5935C11.9159 14.6716 11.8383 14.781 11.7768 14.8341C11.7121 14.8904 11.6054 14.9592 11.5407 14.9873C11.4728 15.0123 11.1849 15.1123 10.9003 15.2061C10.6156 15.2999 10.2016 15.4249 9.97844 15.4843C9.75526 15.5405 9.43504 15.6187 9.26685 15.6531C9.09865 15.6906 8.74933 15.7531 8.49057 15.7937C8.23181 15.8375 7.86307 15.8875 7.66577 15.9062C7.46846 15.925 7.19353 15.9531 7.05121 15.9719C6.90889 15.9875 6.43666 16 6 16C5.56334 16 5.0911 15.9875 4.94879 15.9719C4.80647 15.9531 4.53154 15.925 4.33423 15.9062C4.13693 15.8875 3.76819 15.8375 3.50943 15.7937C3.25067 15.7531 2.90135 15.6906 2.73315 15.6531C2.56496 15.6187 2.24474 15.5405 2.02156 15.4843C1.79838 15.4249 1.38437 15.2999 1.09973 15.2061C0.815094 15.1123 0.527224 15.0123 0.459299 14.9873C0.394609 14.9592 0.287871 14.8904 0.223181 14.8341C0.161725 14.781 0.0840969 14.6716 0.0549864 14.5935C0.0032344 14.4653 0 14.1809 0 11.3272C0 8.46728 0.0032344 8.1891 0.0549864 8.06095C0.0840969 7.98281 0.164959 7.87029 0.232884 7.80778C0.300809 7.74839 0.430189 7.67337 0.51752 7.63899C0.608086 7.60774 0.782749 7.54522 1.13208 7.4202L1.15148 5.79488C1.16765 4.44149 1.18059 4.12268 1.22911 3.88826C1.25822 3.73198 1.31644 3.49443 1.35849 3.35691C1.40054 3.21938 1.49434 2.97246 1.56873 2.80992C1.63989 2.64739 1.76927 2.40672 1.85013 2.27857C1.931 2.15042 2.07978 1.93788 2.18329 1.80973C2.28356 1.68158 2.5035 1.44716 2.6717 1.294C2.83989 1.13772 3.12129 0.918929 3.29919 0.803282C3.47709 0.687634 3.76172 0.531354 3.92992 0.456339C4.09811 0.378199 4.35364 0.278179 4.49596 0.234421C4.63827 0.187537 4.87116 0.131276 5.01348 0.103145C5.1558 0.0781403 5.32399 0.0437585 5.38544 0.0312561C5.4469 0.0156281 5.70889 0.00312561 5.96765 0ZM5.15903 1.71909C5.02641 1.75347 4.80647 1.83161 4.67385 1.89099C4.54124 1.95351 4.33747 2.0629 4.22102 2.13792C4.10458 2.21293 3.90404 2.37546 3.77143 2.50361C3.64205 2.62864 3.44798 2.85681 3.34124 3.01309C3.23774 3.16937 3.10512 3.40692 3.05013 3.54444C2.99515 3.68197 2.92399 3.91952 2.89164 4.0758C2.83666 4.32272 2.83019 4.51026 2.83019 5.66361C2.83019 6.68568 2.83989 6.96699 2.87224 6.96699C2.89164 6.96699 3.06307 6.93886 3.25067 6.90447C3.43827 6.87009 3.81024 6.81383 4.07547 6.77945C4.34394 6.74819 4.88733 6.70131 5.28841 6.68256C5.85121 6.6513 6.17466 6.6513 6.71159 6.67943C7.09326 6.70131 7.63342 6.74507 7.90836 6.77945C8.18329 6.81383 8.56172 6.87009 8.74933 6.90447C8.93693 6.93886 9.10835 6.96699 9.131 6.96699C9.16011 6.96699 9.16981 6.68568 9.16981 5.66048C9.16981 4.51026 9.16334 4.32272 9.10836 4.0758C9.07601 3.91952 9.00485 3.68197 8.94987 3.54444C8.89488 3.40692 8.76226 3.16937 8.65876 3.01309C8.55202 2.85681 8.35795 2.62864 8.22857 2.50361C8.09596 2.37546 7.89542 2.21293 7.77898 2.13792C7.66253 2.0629 7.45876 1.95351 7.32615 1.89099C7.19353 1.83161 6.97358 1.75347 6.84097 1.71909C6.70836 1.68158 6.48841 1.6472 6.35579 1.63469C6.22318 1.62532 6.0841 1.61594 6.04852 1.60969C6.01294 1.60344 5.85121 1.61282 5.69272 1.62844C5.53423 1.64095 5.29164 1.68158 5.15903 1.71909ZM5.40162 8.99551C5.28841 9.04864 5.14286 9.15491 5.05553 9.24556C4.96819 9.33307 4.86469 9.47998 4.81941 9.56749C4.77412 9.65814 4.72237 9.82379 4.70296 9.93632C4.68032 10.0832 4.68032 10.1926 4.7062 10.327C4.72561 10.4302 4.78706 10.5989 4.84528 10.699C4.90674 10.8115 5.02965 10.9553 5.14933 11.0584L5.3531 11.2334C5.3531 13.3557 5.35957 13.4651 5.41455 13.5777C5.4469 13.6464 5.50836 13.7339 5.5504 13.7714C5.59245 13.8089 5.68302 13.8621 5.75094 13.8871C5.81563 13.9152 5.92884 13.9371 6 13.9371C6.07116 13.9371 6.18437 13.9152 6.25229 13.8871C6.31698 13.8621 6.40755 13.8089 6.44959 13.7714C6.49164 13.7339 6.5531 13.6464 6.58544 13.5777C6.64043 13.462 6.6469 13.3557 6.6469 12.318C6.6469 11.5866 6.65984 11.1866 6.67924 11.1866C6.69865 11.1866 6.78922 11.1178 6.88302 11.0365C6.97358 10.9521 7.0965 10.799 7.15472 10.699C7.21294 10.5989 7.27439 10.4302 7.2938 10.327C7.31968 10.1926 7.31968 10.0832 7.29703 9.93632C7.27763 9.82379 7.22588 9.65814 7.18059 9.56749C7.13531 9.47998 7.03181 9.33307 6.94771 9.24556C6.85714 9.15491 6.71159 9.04864 6.59838 8.99551C6.49164 8.9455 6.32345 8.89236 6.22641 8.87361C6.12938 8.85485 6.01294 8.84235 5.96765 8.84548C5.92237 8.8486 5.8221 8.86111 5.74124 8.87673C5.66038 8.89236 5.50836 8.9455 5.40162 8.99551Z"
                fill="#EBEBEB"
              />
            </svg>
          </div>
          {{ question.surprise.title }}
        </div>
        <div class="grid grid-cols-2 gap-2 mt-6">
          <div class="flex gap-2" v-for="(item, index) in question.surprise.items" :key="index">
            <svg
              class="flex-shrink-0"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="11.5" stroke="#3D4A6C" />
              <path d="M7 12L10.6842 16L17 8" stroke="#3D4A6C" />
            </svg>
            <div class="text-sm child-span-red" v-html="item.text"></div>
          </div>
        </div>
        <div class="flex items-center justify-center gap-4 mt-6">
          <div class="text-sm font-bold">+</div>
          <img src="/images/quiz/surprise.png" class="w-7" alt="" />
          <div class="text-sm font-bold">{{ question.surprise.plus }}</div>
        </div>
      </div>
      <!-- Количество подходящих матрасов -->
      <div v-if="current" class="p-6 mt-4 sm:mt-0 bg-light rounded-xl">
        <div class="text-lg font-bold" v-html="progressText"></div>
        <div class="flex items-center justify-between gap-4">
          <div class="text-xs font-bold whitespace-pre-line">{{ quiz.progress.text }}</div>
          <svg
            class="animate-spin"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="loading"
          >
            <circle cx="20" cy="20" r="16.5" stroke="url(#paint0_linear_153_335)" stroke-width="7" />
            <defs>
              <linearGradient
                id="paint0_linear_153_335"
                x1="20"
                y1="-8.85555e-07"
                x2="49.7143"
                y2="40"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#AFAFAF" />
                <stop offset="1" stop-color="#BDBDBD" stop-opacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </div>
    <!-- Размеры -->
    <div
      v-if="additional"
      class="fixed top-0 left-0 z-50 flex w-full h-full px-2 bg-black bg-opacity-50 animated fadeIn"
    >
      <div class="absolute top-0 left-0 w-full h-full" @click="close"></div>
      <div class="relative z-10 max-w-full p-5 m-auto bg-white w-96 rounded-xl">
        <div class="text-lg font-bold text-center">
          {{ additional.optionsTitle }}
        </div>
        <div class="flex items-center gap-4 p-2 my-4 text-center bg-light rounded-xl">
          <div
              class="overflow-hidden h-[150px] flex-grow"
              @wheel.passive="wheels"
          >
            <div
              class="duration-300 scroller"
              :style="currentIndex > 1 ? `transform: translateY(calc(50px * ${currentIndex - 1} * -1))` : ''"
            >
              <div
                v-for="(option, index) in additional.options"
                :key="index"
                class="select-item h-[50px] flex items-center justify-center font-medium text-center duration-300"
                :class="[{ 'text-2xl opacity-100': index === currentIndex, 'opacity-50':  index !== currentIndex}]"
                @click="$emit('select', {'option':additional.options[index], 'question':question})"
              >
                {{ option.value }}
              </div>
            </div>
          </div>
          <div class="space-y-4">
            <svg
              @click="prev"
              class="duration-200 opacity-40 hover:opacity-100 !cursor-pointer"
              width="13"
              height="10"
              viewBox="0 0 13 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6.5 0L12.1292 9.75H0.870835L6.5 0Z" fill="var(--accent)" />
            </svg>
            <svg
              @click="next"
              class="duration-200 opacity-40 hover:opacity-100 !cursor-pointer"
              width="13"
              height="10"
              viewBox="0 0 13 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6.5 10L0.870834 0.25L12.1292 0.25L6.5 10Z" fill="var(--accent)" />
            </svg>
          </div>
        </div>
        <div class="flex gap-2">
          <span
              @click="popupOpened = true"
            v-if="additional.whatsappButton"
            class="flex text-white bg-gradient-to-b from-[#60D66A] to-[#42B649] items-center px-4 gap-4 rounded-xl h-14 leading-4"
            style="background: linear-gradient(180deg, #60d66a, #42b649);"
          >
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.0875579 10.4054C0.0870126 12.2391 0.56827 14.0296 1.48346 15.6077L0 21L5.54303 19.5531C7.07019 20.3817 8.7896 20.819 10.5395 20.8196H10.5442C16.3067 20.8196 20.9976 16.1513 21 10.4136C21.0012 7.63314 19.9145 5.01876 17.9402 3.05188C15.9662 1.08499 13.3409 0.00124168 10.5438 0C4.78055 0 0.0898949 4.66792 0.0875579 10.4055"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.85254 5.93331C7.64943 5.48184 7.43564 5.47274 7.2424 5.46482C7.08437 5.45807 6.90343 5.4585 6.7228 5.4585C6.54205 5.4585 6.24826 5.5264 5.99985 5.79771C5.75129 6.06903 5.05078 6.72489 5.05078 8.05887C5.05078 9.393 6.02245 10.6819 6.15789 10.863C6.29345 11.0438 8.03363 13.8687 10.7895 14.9555C13.0798 15.8587 13.5459 15.6791 14.043 15.6339C14.5402 15.5887 15.6472 14.9781 15.8731 14.345C16.0991 13.712 16.0991 13.1694 16.0313 13.056C15.9635 12.9429 15.7828 12.8752 15.5116 12.7396C15.2404 12.604 13.9074 11.9479 13.6589 11.8576C13.4103 11.7672 13.2295 11.722 13.0488 11.9934C12.868 12.2646 12.3487 12.8752 12.1905 13.056C12.0323 13.2372 11.8742 13.2598 11.603 13.1242C11.3318 12.9882 10.4586 12.7021 9.42263 11.7785C8.61661 11.0599 8.0725 10.1724 7.91423 9.90098C7.75608 9.62978 7.89733 9.48291 8.03332 9.34774C8.15507 9.22626 8.30452 9.03128 8.44008 8.87293C8.57536 8.71462 8.62059 8.60161 8.71096 8.42083C8.80134 8.23977 8.75615 8.08142 8.68837 7.94586C8.62059 7.81027 8.09365 6.46938 7.85254 5.93331Z"
                fill="#42B649"
              />
            </svg>
            {{ additional.whatsappButton }}
          </span>
          <div
            @click="$emit('select', {'option':additional.options[currentIndex], 'question':question})"
            class="flex items-center gap-4 px-4 text-white cursor-pointer bg-accent rounded-xl h-14"
          >
            Далее
            <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L6 6L1 11" stroke="white" />
              <path d="M7 1L12 6L7 11" stroke="white" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <layout-popup v-model="requestconsult" :sended="sended">
      <div class="s-30 w-500">Получить консультацию от эксперта по сну</div>
      <div class="s-16 opacity-80"></div>
      <template slot="form">
        <input v-model="phone" class="ui-input" type="tel" placeholder="Введите телефон" required />
<!--        <phone-mask-input
            v-model="phone"
            autoDetectCountry
            @onValidate="onValidate"
            inputClass="ui-input"
            placeholder=""
            required
        />-->
        <ui-button @click="sendFeedback('Получить консультацию от эксперта по сну' )" style="margin-top: 2em;">Получить консультацию</ui-button>
      </template>
      <div slot="suffix" class="s-12">
        Оставляя Ваш телефон, вы соглашаетесь с <a class="underline" href="/politica/" title="Политика обработки персональных данных">политикой обработки персональных данных</a>
      </div>
    </layout-popup>
    <layout-popup v-model="popupOpened" :sended="sended">
      <div class="s-30 w-500">Нет нужного размера, у товара?</div>
      <div class="s-16 opacity-80">Оставьте заявку на расчет нестандартного размера или формы</div>

      <template slot="form">
        <input required placeholder="Как Вас зовут" v-model="name" type="text" class="ui-input" />
        <input required placeholder="your_email@example.com" type="email" v-model="email" class="ui-input" />
        <input @focus="errorBorder" v-model="phone" class="ui-input" type="tel" placeholder="Введите телефон" required />
<!--        <phone-mask-input
            v-model="phone"
            autoDetectCountry
            @onValidate="onValidate"
            inputClass="ui-input"
            placeholder=""
            required
        />-->

        <div class="sizes">
          <input required placeholder="Длина" v-model="length" type="number" class="ui-input" />
          <input required placeholder="Ширина" v-model="width" type="number" class="ui-input" />
        </div>
        <textarea placeholder="Дополнительная информация" v-model="text" rows="5" class="ui-input"></textarea>
        <ui-button @click="sendNoSizeTovar">Оставить заявку</ui-button>
      </template>

      <div slot="suffix" class="s-12">
        Оставляя Ваш email, вы соглашаетесь с политикой обработки персональных данных
      </div>
    </layout-popup>
  </div>
</template>

<style>
  .quiz-container {
    margin-bottom: 60px;
  }
  .sizeclothes{
    padding: 0 11px;
  }
  .select-item{
    cursor: pointer;
  }
</style>

<script>
export default {
  props: {
    type: "mattress",
    question: {
      type: Object,
      required: true
    },
    current: {
      type: Number,
      required: true
    },
    value: {
      type: String,
      required: false
    },
    filter: {
      type: Object
    },
    category: {
      type: Number,
      required: true
    },
  },
  inject: ['quiz', 'currentStepIndex', 'branch', 'arVariableSite'],
  data() {
    return {
      additional: null,
      currentIndex: 0,
      loading: false,
      count: 0,
      progressText: "",
      ids: {},
      phone: "",
      email: "",
      name: "",
      length: "",
      width: "",
      text: "",
      requestconsult: false,
      popupOpened: false,
      sended: false,
      validPhone: false,
    }
  },
  created() {
    this.$bus.$on('updateSended', () => {
      this.sended=false;
      this.requestconsult=false;
    });
/*
    window.__quiz__.branches.options[this.category].steps.forEach((step, index) => {
      if( index===0 ){ return; }
      step.options = [];
    });
*/
    if( typeof this.filter != "undefined" ){
      const filterNew = {};
      Object.keys(this.filter).forEach(key => {
        if ( Number( key) <= this.current) {
          filterNew[key] = this.filter[key];
        }
      });
      this.$emit('filters', filterNew)
    }
    this.progressTitle();
  },
  methods: {
    wheels(wheeling) {
      if(wheeling.deltaY>0){
        this.next();
      }else{
        this.prev();
      }
    },
    num2word: function(number, words) {
      if (words.length == 1) return words[0]

      let num = number %  100
      if (num > 19) {
        num = num % 10
      }

      if (words[0] == 'матрас' && (num == 3 || num == 4)) return words[1]

      switch (num) {
        case 1:
          return words[0]
        case 2:
          return words[1]
        default:
          return (words.length > 2) ? words[2] : words[1]
      }
    },
    async progressTitle() {
      this.loading = true;
      let that = this
      if(this.$store.state.admin) {
        console.log("progressTitle this.filter", this.filter);
        console.log("progressTitle this.$store.state", this.$store.state);
      }
      this.$store.commit('addAnswers', this.filter)
      var bodyFormData = new FormData();
      bodyFormData.append('data', JSON.stringify(this.filter));
      bodyFormData.append('type', this.type);
      await this.$axios({
        method: 'post',
        url: '/ajax/quiz/getQuizData.php',
        data: bodyFormData,
      }).then(function (response) {
        that.count = response.data.TOTAL_SKU
        that.loading = false
        that.$store.commit('quizCountChange', response.data.TOTAL_SKU);
        that.$store.commit('addFilterToStore', that.filter);
        that.$store.commit('addFiltersQuiz', response.data.FILTER);
        localStorage.setItem('quizids', JSON.stringify(response.data.SKU_IDS));
        if(that.type!=="pillows" && response.data.ARRRIDITY ){
          let ridity = window.__quiz__.branches.options[that.category].steps.find(idity => idity.id === 4)
          ridity.options = response.data.ARRRIDITY;
        }

      });
      // this.progressText = this.quiz.progress.title.replace('{{count}}', '<span class="text-brightRed">' + this.$store.state.quizCount + '</span>')
      if(this.type == "pillows") {
        this.progressText = 'Вам подходят ' + '<span class="text-brightRed">' + this.$store.state.quizCount + '</span> ' + this.num2word(this.$store.state.quizCount, ['подушка', 'подушки', 'подушек'])
      }else{
        this.progressText = 'Вам подходят ' + '<span class="text-brightRed">' + this.$store.state.quizCount + '</span> ' + this.num2word(this.$store.state.quizCount, ['матрас', 'матраса', 'матрасов'])
      }
    },
    next() {
      if (this.currentIndex < this.additional.options.length - 1) {
        this.currentIndex++
      } else {
        this.currentIndex = 0
      }
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      } else {
        this.currentIndex = this.additional.options.length - 1
      }
    },
    close() {
      this.additional = null
    },
    select(option) {

      console.log("option", option);

      if (option.options) {
        this.additional = option
        return
      }
      this.$emit('select', {"option":option, "question":this.question})
    },
    funRequestconsult(){
      this.requestconsult=true;
      return false;
    },
    onValidate(ev){
      this.validPhone = !!ev.isValidByLibPhoneNumberJs;
    },
    sendFeedback( text ) {
      /*if( !this.validPhone ){return false;}*/
      let inputTelVal = this.phone.replace(/^\D+/g, '').replace(/[^0-9]/g, '');
      const PHONE_REGEXP = /^\d+$/;
      const prone = PHONE_REGEXP.test(inputTelVal);
      if( !prone || ( typeof inputTelVal.length === "undefined" ||  inputTelVal.length < 7) ){
        document.querySelector('input[type="tel"]').classList.add('error');
        return false;
      } else {
        document.querySelector('input[type="tel"]').classList.remove('error');
      }

      this.$axios({
        url: '/ajax/?feadback=Y',
        method: 'post',
        params: {
          name: "",
          email: "",
          phone: this.phone,
          text: text,
          header: text,
          url: location.href
        }
      }).then(response => {
        if (response.status == 200 && response.data.success) {
          //console.log( "response", response );
          this.sended = true;
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'quiz_form');

            if(text == "Получить консультацию от эксперта по сну") {
              let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
              ym(yaCounterId2, 'reachGoal', 'sleep_consultation');
              ym(yaCounterId2, 'reachGoal', 'all_forms');
            }
          }
        }else{
          console.log('Error feedback success: false')
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
      //this.loading = false;
    },
    sendNoSizeTovar(){
      /*if( !this.validPhone ){return false;}*/
      let inputTelVal = this.phone.replace(/^\D+/g, '').replace(/[^0-9]/g, '');
      const PHONE_REGEXP = /^\d+$/;
      const prone = PHONE_REGEXP.test(inputTelVal);
      if( !prone || ( typeof inputTelVal.length === "undefined" ||  inputTelVal.length < 7) ){
        document.querySelector('input[type="tel"]').classList.add('error');
        return false;
      } else {
        document.querySelector('input[type="tel"]').classList.remove('error');
      }
      this.$axios({
        url: '/ajax/?addCustomSize=Y',
        method: 'post',
        params: {
          site_id: this.$store.state.siteid,
          template_site: this.$store.state.langs.TEMPLATE_SITE,

          name: this.name,
          email: this.email,
          phone: this.phone,
          text: this.text,
          length: this.length,
          width: this.width,
          url: location.href
        }
      }).then(response => {
        if (response.status == 200 && response.data.success) {
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'nestandart_sentForm');
          }
          this.sended = true;
        }else{
          console.log('Error addCustomSize success: false')
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
    },
    errorBorder(){
      const phoneError = document.querySelector('input[type="tel"]');
      if(phoneError) {
        phoneError.classList.remove('error');
      }
    }
  },
  components: {
    vueScroll: () => import('vuescroll'),
    'layout-popup': () => import('@/components/layout/layout-popup'),
    'ui-button': () => import('@/components/ui/ui-button.vue'),
    PhoneMaskInput: () => import('vue-phone-mask-input'),
  }
}
</script>
